module.exports = __webpack_public_path__ + "static/phoneLit-ebb2ced403ecd5743a18698be20a7d62.png";